"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _localization = require("@lt/localization");
var _FacilitiesTitle = _interopRequireDefault(require("../FacilitiesTitle"));
var _FacilitiesList = _interopRequireDefault(require("../FacilitiesList"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FacilitiesBlock = function FacilitiesBlock(_ref) {
  var items = _ref.items,
    className = _ref.className,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    title = _ref.title,
    showItemBackground = _ref.showItemBackground,
    showBestItemBackground = _ref.showBestItemBackground,
    _ref$inColumns = _ref.inColumns,
    inColumns = _ref$inColumns === void 0 ? false : _ref$inColumns;
  var _useState = (0, _react.useState)(!isMobile),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var bestItems = [];
  var otherItems = [];
  items.forEach(function (item) {
    return item.best ? bestItems.push(item) : otherItems.push(item);
  });
  var handleToggle = function handleToggle() {
    setOpened(function (prev) {
      return !prev;
    });
  };
  var isRoomFacilities = title === t('hotel.facilities.hasRooms');
  var isOpened = !isMobile || opened || isRoomFacilities;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_FacilitiesTitle["default"], {
    isMobile: isMobile,
    count: items.length,
    isOpened: opened,
    onToggle: isMobile && !isRoomFacilities ? handleToggle : undefined
  }, title), bestItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_FacilitiesList["default"], {
    items: bestItems,
    showBestTitle: true,
    showItemCheck: true,
    showItemBackground: showBestItemBackground,
    isMobile: isMobile,
    inColumns: inColumns,
    inBlock: true
  }), otherItems.length > 0 && isOpened && /*#__PURE__*/_react["default"].createElement(_FacilitiesList["default"], {
    inBlock: true,
    items: otherItems,
    showItemBackground: showItemBackground,
    isMobile: isMobile,
    inColumns: inColumns
  }));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FacilitiesBlock);